import { MessageCircle } from "lucide-react";
import { useLang } from "../i18n";
import { IMG, waQuote } from "../data/site";
import Seo, { breadcrumbLd } from "../components/Seo";
import { Reveal, Kicker } from "../components/Reveal";

export default function WorksPage() {
  const { lang, t } = useLang();
  const prefix = lang === "ca" ? "/ca" : "";

  return (
    <div data-testid="works-page" className="pt-32">
      <Seo
        title={t("seo.works.title")}
        desc={t("seo.works.desc")}
        path="/trabajos-realizados"
        jsonLd={breadcrumbLd([
          { name: "EcoGlow Detailing", path: prefix || "/" },
          { name: t("nav.works"), path: `${prefix}/trabajos-realizados` },
        ])}
      />
      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">
        <Reveal><Kicker>{t("worksPage.kicker")}</Kicker></Reveal>
        <Reveal delay={0.1}>
          <h1 className="mt-4 max-w-3xl font-display text-4xl font-black uppercase tracking-tight text-white sm:text-5xl lg:text-6xl">
            {t("worksPage.title")}
          </h1>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-zinc-400">{t("worksPage.sub")}</p>
        </Reveal>

        <Reveal delay={0.25}>
          <div className="mt-14 grid items-center gap-10 rounded-2xl border border-white/5 bg-[#121212] p-8 lg:grid-cols-2 lg:p-12">
            <div className="relative overflow-hidden rounded-xl">
              <img src={IMG.polishing} alt={lang === "ca" ? "Poliment professional de pintura" : "Pulido profesional de pintura"} loading="lazy" className="aspect-[4/3] w-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/70 to-transparent" />
              <p className="absolute bottom-4 left-4 max-w-xs font-mono2 text-[10px] uppercase tracking-[0.2em] text-zinc-400">
                {t("home.worksNote")}
              </p>
            </div>
            <div>
              <p data-testid="works-empty-message" className="text-base leading-relaxed text-zinc-300">{t("worksPage.empty")}</p>
              <a
                href={waQuote(lang === "ca" ? "Hola EcoGlow! Podeu ensenyar-me exemples de treballs fets?" : "¡Hola EcoGlow! ¿Podéis enseñarme ejemplos de trabajos realizados?")}
                target="_blank" rel="noopener noreferrer"
                data-testid="works-whatsapp-button"
                className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#63E51D] px-7 py-3.5 font-display text-lg font-bold uppercase tracking-wide text-black transition-all duration-300 hover:scale-[1.03] hover:shadow-[0_0_25px_rgba(99,229,29,0.4)]"
              >
                <MessageCircle className="h-5 w-5" /> WhatsApp
              </a>
            </div>
          </div>
        </Reveal>
      </section>
      <div className="pb-24" />
    </div>
  );
}
